import styled, { css } from "styled-components";

interface IContainer {
  checked?: boolean;
  disabled?: boolean;
}

export const Container = styled.section<IContainer>`
  height: 51px;
  display: flex;
  align-items: center;
  user-select: none;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  background: ${({ theme }) => theme.colors.surface.surface};
  padding: 10px 32px;
  margin: 10px 0;
  cursor: pointer;

  ${({ checked }) => checked && css`
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.primary.primaryContainer}, ${theme.colors.surface.surface})`} !important;
  `}

  ${({ disabled }) => disabled && css`
    opacity: 0.5;
  `}

  .iconContainer {
    margin-left: 35px;
  }

  .disciplinaTitle {
    margin-left: 18px;
    padding-top: 4px;
    cursor: pointer;

    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }

  .disciplinaAcronym {
    margin-left: 8px;
    padding-top: 4px;
    cursor: pointer;

    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  }
`;
